const HisPaymentCard = ({ color, sx }) => {
  const fillColor = color ?? "#0B4EDB";
  const _sx = sx ?? {};

  return (
    <svg
      style={_sx}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 6C0.9 6 0 6.9 0 8V10H30V8C30 6.9 29.1 6 28 6H2ZM0 14V22C0 23.1 0.9 24 2 24H28C29.1 24 30 23.1 30 22V14H0ZM3.02 18.08H7.08C7.64 18.08 8.08 18.52 8.08 19.08V20.86C8.08 21.4 7.64 21.86 7.08 21.86H3.02C2.48 21.86 2.02 21.4 2.02 20.86V19.08C2.02 18.52 2.48 18.08 3.02 18.08Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default HisPaymentCard;
